import { baseGet } from './api.js';

export async function getApiTokenCIMT(orgId) {
  try {
    const cimtToken = localStorage.getItem('cimtToken');
    if (cimtToken) {
      return cimtToken;
    }
    return await setApiTokenCIMT(orgId);
  } catch (error) {
    console.error('Error getting getApiTokenCIMT', error);
  }
}

export async function setApiTokenCIMT(orgId) {
  try {
    localStorage.setItem('cimtToken', '');
    localStorage.setItem('ebosLoginDone', '0');
    const {token} = await baseGet(`token/ebosByOrg?orgId=${orgId}`);
    localStorage.setItem('cimtToken', token);
    return token;
  } catch (error) {
    console.error('Error getting setApiTokenCIMT', error);
  }
}